<!--
	Per evitare codice duplicato in più parti dell'applicazione, si è scelto di creare questo componente, 
	che raccoglie tutti i metodi relativi ad un backup.
	Ogni metodo di questo componente:
	1 - Viene chiamato con this.$root.$emit([nome_metodo], [argomenti]);
	2 - Genera la risposta con thi.$root.$emit([nome_metodo]_feedback, feedback);
	3 - Ingloba la logica principale a termine delle operazioni (chiusura dialog, reindirizzamenti), diminuendo il codice nel metodo chiamante
	4 - ha il blocco finally che consente di inviare SEMPRE una risposta
	Ogni metodo si comporta nel seguente modo:
	1 - Chiede conferma all'utente dell'operazione scelta (esempio: Vuoi avviare il job... ?)
	2 - Se l'utente non conferma l'operazione, il metodo:
	2.1 - imposta feedback.status a $ResultValue.NeverExecuted per far capire che non bisogna fare nulla;
	2.2 - emette la risposta.
	Il metodo che riceve la risposta può terminare l'ascolto di queste risposte (this.$root.$off([nome_metodo]_feedback))
	3 - Se l'utente conferma l'operazione, il metodo imposta feedback.status a $ResultValue.Running 
	per far capire che l'operazione scelta è in corso. 
	Il metodo emette questa risposta per permettere di impostare eventuali spinner.
	Il metodo che riceve la risposta NON deve terminare l'ascolto di queste risposte (this.$root.$off([nome_metodo]_feedback)), 
	perché deve ricevere la risposta definitiva.
	4 - Se l'operazione termina con successo, il metodo:
	4.1 - imposta feedback.status a $ResultValue.OK;
	4.2 - allega a feedback il job;
	4.3 - emette la risposta.
	Il metodo che riceve la risposta può terminare l'ascolto di queste risposte (this.$root.$off([nome_metodo]_feedback))
	5 - Se l'operazione termina con errori, il metodo:
	5.1 - imposta feedback.status a $ResultValue.ERROR;
	5.2 - allega a feedback il job;
	5.3 - emette la risposta.
	Il metodo che riceve la risposta può terminare l'ascolto di queste risposte (this.$root.$off([nome_metodo]_feedback))
-->
<template></template>
<script>
import { BACKUP_MESSAGES } from '../../utils/messages';
import { isValid, waitSeconds } from '../../utils/utilitiesmodule';

export default {
	name: "BackupManager",

	created() {
		this.$root.$on("saveJob", job => this.saveJob(job));
		this.$root.$on("runJob", job => this.runJob(job));
		this.$root.$on("pauseJob", job => this.pauseJob(job));
		this.$root.$on("deleteJob", job => this.deleteJob(job));
		this.$root.$on("deleteRestoreJob", job => this.deleteRestoreJob(job));
		this.$root.$on("duplicateJob", job => this.duplicateJob(job));
		this.$root.$on("configureRestoreJob", job => this.configureRestoreJob(job));
		this.$root.$on("startRestore", (job, message) => this.startRestore(job, message));

		this.$root.$on("addBackupsToPage", backups_received => this.manageReceivedBackups(backups_received));

	},
	beforeDestroy() {
		this.$root.$off("saveJob");
		this.$root.$off("runJob");
		this.$root.$off("pauseJob");
		this.$root.$off("deleteJob");
		this.$root.$off("deleteRestoreJob");
		this.$root.$off("duplicateJob");
		this.$root.$off("configureRestoreJob");
		this.$root.$off("startRestore");

		this.$root.$off("addBackupsToPage");
	},
	data() {
		return {
			feedback: {
				status: this.$ResultValue.NeverExecuted,
				job: null
			},
		}
	},
	methods: {
		async saveJob(job) {
			this.clear();
			let self=this;

			var dialogID=Math.floor(100000+Math.random()*900000).toString();
			this.$root.$on(dialogID, async ok => {
				try {

					if (!ok) {
						self.feedback.status=self.$ResultValue.NeverExecuted;
						return;
					}

					self.feedback.status=self.$ResultValue.Running;
					self.$root.$emit("saveJob_feedback", self.feedback);

					//prepara feedback
					await self._saveJob_confirmed(job);

				} finally {
					// if ($("#newText")&&$("#newText").parent()&&$("#newText").parent().parent()) {
					// 	Metro.dialog.close($("#newText").parent().parent());
					// }
					self.$root.$off(dialogID);
					self.$root.$emit("saveJob_feedback", self.feedback);
				}

			});

			var dialogTitle=this.$t("Save Backup Job");
			var dialogLabel=this.$t("Do you want save backup job '{0}'?", { 0: job.name });

			//Avvio la richiesta che mi risponderà con un $emit
			this.$root.openYesNoDialog(dialogID, dialogTitle, dialogLabel);
			//this.$root.openYesNoDialog(dialogID, dialogTitle, dialogContent, "Save", "Close", "js-dialog-ok secondary","js-dialog-close");
		},

		async _saveJob_confirmed(job) {

			//Se il pc è offline, imposto il salvataggio come fallito
			if (!this.$root.connectionsStates[this.$session.getRoomPC().id]) {
				this.feedback.status=this.$ResultValue.Error;
				this.feedback.job=job;
				this.$root.toast(this.$t(BACKUP_MESSAGES.NOT_SAVED, { 0: job.name }), "alert")
				return;
			}

			var isNew=!isValid(job.id);
			var method=isNew? "CREATEBACKUP":"EDITBACKUP";

			//Step 1 : Invio la richiesta all'API di salvare il job sul database
			var api_response=!isValid(job.id)?
				await this.$api.createBackup(job):
				await this.$api.editBackup(job)

			// Step 2 : Se il salvataggio sul database non è andato a buon fine, imposto il salvataggio come fallito
			if (!api_response) {
				this.feedback.status=this.$ResultValue.Error;
				this.feedback.job=job;
				//this.$root.toast(this.$t(BACKUP_MESSAGES.NOT_SAVED, { 0: job.name }), "alert")

				return;
			}

			//Step 3 : Se il salvataggio sul database è andato a buon fine, eseguo la richiesta socket
			method=isNew? "CreateJob":"SaveJob";
			var socket_response=await this.$root.socket(method, api_response);

			//Step 4 : Se il salvataggio non è andato a buon fine imposto il salvataggio come fallito 
			//socket_response è true/false
			if (!socket_response) {
				this.feedback.status=this.$ResultValue.Error;
				this.feedback.job=api_response;
				return;
			}

			this.feedback.status=this.$ResultValue.OK;
			this.feedback.job=api_response;
			//Sarà un messaggio dall'agent ad essere visualizzato
			//this.$root.toast(this.$t(BACKUP_MESSAGES.SAVED, { 0: job.name }), "success")

		},


		async runJob(job) {
			this.clear();
			let self=this;

			var dialogID=Math.floor(100000+Math.random()*900000).toString();
			this.$root.$on(dialogID, async ok => {
				try {
					if (!ok) {
						self.feedback.status=self.$ResultValue.NeverExecuted;
						return;
					}

					self.feedback.status=await self.$root.socket("RunJob", job.id)
						? self.$ResultValue.OK
						:self.$ResultValue.Error;
				} finally {
					self.$root.$emit("runJob_feedback", self.feedback);
					self.$root.$off(dialogID);
				}
			});

			var dialogTitle=this.$t("Start backup");
			var dialogLabel=this.$t("Do you want to start backup job '{0}'?", { 0: job.name });

			this.$root.openYesNoDialog(dialogID, dialogTitle, dialogLabel);
		},

		pauseJob(job) {
			this.clear();
			let self=this;

			var dialogID=Math.floor(100000+Math.random()*900000).toString();
			this.$root.$on(dialogID, async ok => {
				try {
					if (!ok) {
						self.feedback.status=self.$ResultValue.NeverExecuted;
						return;
					}

					self.feedback.status=self.$ResultValue.Running;
					self.$root.$emit("pauseJob_feedback", self.feedback);

					self.feedback.status=await self.$root.socket("stopjob", job.id)
						? self.$ResultValue.OK
						:self.$ResultValue.Error;
				} finally {
					self.$root.$emit("pauseJob_feedback", self.feedback);
					self.$root.$off(dialogID);
				}
			});

			var dialogTitle=this.$t("Stop backup");
			var dialogLabel=this.$t("Do you want to stop backup job '{0}'?", { 0: job.name });

			this.$root.openYesNoDialog(dialogID, dialogTitle, dialogLabel);
		},

		async deleteJob(job) {
			this.clear();
			let self=this;
			var dialogID=Math.floor(100000+Math.random()*900000).toString();

			this.$root.$on(dialogID, async ok => {
				try {
					if (!ok) {
						return;
					}

					self.feedback.status=self.$ResultValue.Running;
					self.$root.$emit("deleteJob_feedback", self.feedback);

					ok=await self.$api.deleteBackup(job.id, job.name);
					if (!ok) {
						this.feedback.status=self.$ResultValue.Error;
						this.feedback.job=job;
						return;
					}
					ok=await self.$root.socket("DeleteJob", job.id);
					if (!ok) {
						this.feedback.status=self.$ResultValue.Error;
						this.feedback.job=job;
						return;
					}

					self.$root.$emit("DeletedJob", job.id);
					this.feedback.status=self.$ResultValue.OK;
					this.feedback.job=job;
				} finally {
					self.$router.removeHash(); // prototype implementato in main.js
					self.$root.$off(dialogID);
					self.$root.$emit("deleteJob_feedback", self.feedback);

				}
			});

			this.$root.openYesNoDialog(dialogID, this.$t("Delete job"), this.$t("Delete job \"{0}\"?", { 0: job.name }));

		},

		async duplicateJob(job) {
			this.clear();
			let self=this;

			var dialogID=Math.floor(100000+Math.random()*900000).toString();
			this.$root.$on(dialogID, async backupName => {
				try {

					if (backupName=='') {
						self.feedback.status=self.$ResultValue.NeverExecuted;
						return;
					}

					self.feedback.status=self.$ResultValue.Running;
					//Step 1 : Recupero il job tramite API
					//se si verifica job.sources==undefined vuol dire che il job passato è quello arrivato via socket
					var APIjob=job.sources==undefined
						? await this.$api.getBackupWithID(job.id)
						:job;
					if (APIjob==null) {
						this.$root.toast(this.$t(BACKUP_MESSAGES.NOT_FOUND, { 0: job.name }), "warning");
						self.feedback.status=self.$ResultValue.Error;

						//this.$root.$emit("CLOSEBACKUPVIEW");
						return;
					}

					var newJob={
						"id": null,
						"name": backupName,
						"type": APIjob.type,
						"id_computer": APIjob.id_computer,
						"sources": APIjob.sources.map(s => {
							s.id=null;
							s.id_job=null;
							return s;
						}),
						"destinations": APIjob.destinations.map(d => {
							d.id=null;
							d.id_job=null;
							return d;
						}),
						"scheduling": APIjob.scheduling,
						"options": APIjob.options
					};

					//prepara feedback
					await self._saveJob_confirmed(newJob);



				} finally {
					self.$root.$off(dialogID);
					self.$root.$emit("CLOSEBACKUPVIEW");

					if (self.feedback.status==self.$ResultValue.OK) {
						await waitSeconds(1.5);//dò tempo per visualizzare il messaggio prima del reindirizzamento
						self.$router.push("/computers/computer/"+self.feedback.job.id_computer+"/backup/"+self.feedback.job.id);
						location.reload();
					}
				}

			});

			var dialogTitle=this.$t("Duplicate Backup Job '{0}'", { 0: job.name });
			var dialogLabel=this.$t('Insert a name for new Backup Job');
			var placeholder=this.$t('Insert a name');
			var maxlength=100;
			var initialValue=job.name+" (DUPLICATED)";
			//Avvio la richiesta che mi risponderà con un $emit
			this.$root.openInsertTextDialog(dialogID, dialogTitle, dialogLabel, placeholder, initialValue, maxlength);
		},

		async configureRestoreJob(job) {
			this.$root.$emit('CLOSECONFRESTOREFROMBACKUPJOB');
			this.clear();
			if (job.sources==undefined) {
				job=await this.$api.getBackupWithID(job.id);
				if (!job) {
					this.$root.$emit("CLOSERESTOREDIALOG");
					return;
				}
			}
			this.$root.$emit("OPENRESTOREDIALOG", parseInt(job.type.toString()), job/*job.id, job.name*/);

		},


		async startRestore(backupName, message) {
			this.clear();
			let self=this;

			var dialogID=Math.floor(100000+Math.random()*900000).toString();
			this.$root.$on(dialogID, async ok => {
				try {
					if (!ok) {
						self.feedback.status=self.$ResultValue.NeverExecuted;
						return;
					}

					// if (job.sources==undefined) {
					// 	job=await this.$api.getBackupWithID(job.id);
					// }
					// this.$root.$emit("OPENRESTOREDIALOG", parseInt(job.type.toString()), job/*job.id, job.name*/);

					self.feedback.status=self.$ResultValue.OK;
				} finally {
					self.$root.$emit("startRestore_feedback", self.feedback);
					self.$root.$off(dialogID);
					//this.$root.$emit("CLOSEBACKUPVIEW");
				}
			});

			var dialogTitle=this.$t("Restore backup");
			var dialogLabel=isValid(message)? message:this.$t("Do you want to restore backup job '{0}'?", { 0: backupName });

			this.$root.openYesNoDialog(dialogID, dialogTitle, dialogLabel);
		},

		manageReceivedBackups(backups_received) {
			let self=this;
			var realtimeJob=null, backupForView={};
			self.$root.forceRefreshID+=1;
			self.$root.$emit("SETPAGEPROP", "socket_backups", backups_received);

			//è aperto un job in edit
			if (![undefined, ''].includes(self.$route.params.idBackup)&&backups_received[self.$route.params.idBackup]!=undefined) {
				realtimeJob=backups_received[self.$route.params.idBackup];
			}

			//è aperta una job view
			if (self.$root.backupIDForView!=null&&backups_received[self.$root.backupIDForView]!=undefined) {
				realtimeJob=backups_received[self.$root.backupIDForView];
			}

			if (realtimeJob==null) {
				return;
			}
			//Mando solo i dati che cambiano in realtime
			backupForView.isRunning=realtimeJob.isRunning? "R":"NR";
			backupForView.progress=realtimeJob.isRunning? realtimeJob.progress:null;
			backupForView.current_operation=realtimeJob.current_operation;
			backupForView.processed_data_string=realtimeJob.processed_data_string;
			backupForView.last_result=realtimeJob.lastresult
			self.$root.$emit("SETPAGEPROP", "job", backupForView);


			/*PROVA FUNZIONANTE PER ORDINARE I BACKUP DA QUELLO AVVIATO PIU' RECENTEMENTE A QUELLI MAI AVVIATI
			self.socket_backups = Object.entries(self.socket_backups)
				.sort(([, a], [, b]) => self.orderJobs(a, b))
				.reduce((r, [k, v]) => ({...r, [k]: v }), {});*/
		},

		async deleteRestoreJob(job) {
			this.clear();
			let self=this;
			var dialogID=Math.floor(100000+Math.random()*900000).toString();

			this.$root.$on(dialogID, async ok => {
				try {
					if (!ok) {
						return;
					}

					self.feedback.status=self.$ResultValue.Running;
					self.$root.$emit("deleteRestoreJob_feedback", self.feedback);

					ok=await self.$api.deleteRestore(job.id, job.restore_name);
					if (!ok) {
						this.feedback.status=self.$ResultValue.Error;
						this.feedback.job=job;
						return;
					}
					
					this.feedback.status=self.$ResultValue.OK;
					this.feedback.job=job;
				} finally {
					self.$router.removeHash(); // prototype implementato in main.js
					self.$root.$off(dialogID);
					self.$root.$emit("deleteRestoreJob_feedback", self.feedback);

				}
			});

			this.$root.openYesNoDialog(dialogID, this.$t("Delete restore"), this.$t("Delete restore \"{0}\"?", { 0: job.restore_name }));

		},


		clear() {
			this.feedback.status=this.$ResultValue.NeverExecuted;
			this.feedback.job=null;
		}

	}
}
</script>